<div class="p-t-1 p-b-1">
    <div class="h2 m-t-1-s"
         *iCms="header of content; skipEmpty: true">
    </div>

    <div class="p1"
         [class.col-13]="checked"
         [ngClass]="marginTop || ''"
         *iCms="additional_text of content; skipEmpty: true">
    </div>
</div>
